import { fetcher } from "@utils/fetcher";
import { IFetchOptions } from "itsf-ui-common";
import { mapTerminationReasons } from "@modules/accounts/mappers";
import { ITerminationReasons } from "@modules/accounts/interfaces/models/ITerminationReasons";
import { EServiceGroup } from "@pages/AccountDetails/interface/IAccountDetailsPage";
import { getTerminationReasonsRoute } from "@api-routes/accounts";

export const getTerminationReasons = (serviceGroup: EServiceGroup, options: IFetchOptions = {}) =>
    fetcher<ITerminationReasons>(getTerminationReasonsRoute(serviceGroup), {
        ...options,
        mapper: mapTerminationReasons,
    });
